<template>
    <full-page ref="fullpage" :options="opts">
        <slot />
    </full-page>
</template>

<script>
    import 'fullpage.js/dist/fullpage.css';
    import 'fullpage.js/vendors/scrolloverflow';
    import VueFullPage from 'vue-fullpage.js';
    import Vue from 'vue';

    Vue.use(VueFullPage);

    export default {
        name: 'full-page-section',

        props: {
            options: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            /**
             *  sets the options for fullpage
             *  @return {Object}
             */
            opts() {
                return {
                    ...this.options,
                    onLeave: this.onSlideLeave,
                    licenseKey: 'EEFD478F-FA704EF6-9EE48DD3-C65980B1',
                };
            },
        },

        methods: {
            /**
             * on slide leave
             *
             * @param {object} section
             * @param {object} origin
             */
            onSlideLeave(section, origin) {
                this.$store.commit('layout/setActiveSection', origin.index + 1);
            },
        },
    };
</script>
